import client from '../httpClient';
/**
 * @param {{customerIds:number[], userId:number}},
 * @return {Promise<{ data:{
 * customer:{
 * id:number,
 * memberId:number,
 * fullName:string,
 * status:string,
 * statusCode:string,
 * memberStatusCode:string,
 * hashCustomerId:string,
 * }
 * lastReceivedAt:string,
 * user:string,
 * } }>}
 */
const customerPostLineReceptionsApi = async (params) => {
  return client.post('/customers/lineReceptions', params);
};

export default customerPostLineReceptionsApi;
